import { Affected } from "../Model/Affected";
import { Query } from "../Model/Query";
import { Third } from "../Model/Third";
import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
export class AffectedService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(affectedId, diligenceId) {
        if (affectedId) {
            const response = await this.apiService.get('affected/' + diligenceId + '/third_id/' + affectedId);
            if (!response.ok) {
                throw new Error(`Error al obtener el afectado.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener affectedId.`);
        }
    }
    async findByDiligenceNumber(affectedId) {
        if (affectedId) {
            const response = await this.apiService.get('affected/' + affectedId);
            if (!response.ok) {
                throw new Error(`Error al obtener el afectado.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener affectedId.`);
        }
    }
    async findThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`affected/thirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async saveAffected(affected) {
        if (affected) {
            const response = await this.apiService.post('affected', affected);
            if (!response.ok) {
                throw new Error(`Error al guardar el afectado.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener affected.`);
        }
    }
    async createAffected(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const dateNow = new Date();
            const complainant = new Affected({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                affectedThird: thirdId,
                manifestation: " ",
                date: dateNow.toString(),
                presents: " ",
                userId: getCurrentUser().id,
                third_name: null
            });
            const response = await this.apiService.post('affected', complainant.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el afectado Global de una diligencia`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el afectado Global`);
        }
    }
    async deleteAffected(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('affected/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el afectado.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener affected.`);
        }
    }
}
